import React, { useEffect, useState } from 'react';
import { InteractiveTooltip, Button } from '@livecommerce/design-system';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import { useTooltipContext } from 'contexts/TooltipContext.jsx';
import constants from 'constants/tooltips.js';
import { trackingService } from 'services/tracking/TrackingService.js';
import { useLocation } from 'react-router-dom';

const AIItemTooltip = ({ onAction, children }) => {
  const { t } = useLocalization();
  const { pathname } = useLocation();

  const {
    isTooltipVisible,
    updateTooltipContext,
  } = useTooltipContext();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const canShowTooltip = !pathname?.includes('ai');
    setIsVisible(canShowTooltip && isTooltipVisible(constants.AI_NAVIGATION));
  }, [pathname, isTooltipVisible]);

  const actions = () => {
    const _onAction = () => {
      trackingService.track({
        eventType: 'aiNavigation-tooltip:showMe',
      });
      if (typeof onAction === 'function') onAction();
      closeTooltip();
    };

    return (
      <Button
        variant="solid"
        theme="dark"
        type="button"
        onClick={_onAction}
      >
        {t('aiNavigationTooltip.button')}
      </Button >
    );
  };

  const closeTooltip = () => {
    updateTooltipContext(constants.AI_NAVIGATION);
    setIsVisible(false);
  };

  return (
    <InteractiveTooltip
      title={t('aiNavigationTooltip.title')}
      description={t('aiNavigationTooltip.description')}
      content={actions()}
      variant="orange"
      onClose={closeTooltip}
      isShown={isVisible}
      minWidth="300px"
      style={{
        zIndex: 1,
      }}
    >
      {children}
    </InteractiveTooltip>
  );
};

export default AIItemTooltip;
